import { useContext } from "react"

import { DataTableContext } from "./DataTable"

import RowGroupTitle from "./RowGroupTitle"
import DataRows from "./DataRows"
import RowGroupSummary from "./RowGroupSummary"

export default function RowGroup({
  groupNumber,
  data,
  groupKey,
  groupSize,
  groupValues,
  expanded,
  onRowClick,
  onGroupCollapseToggle,
}) {
  const { showGroupTotals, showDetails, groupTotals, stickyGroupTotals } =
    useContext(DataTableContext)

  const showRowGroupTitle = showDetails
  const showDataRows = expanded && showDetails

  const hasMultipleStickyRows = data.filter((row) => row.sticky).length > 1
  const hasAnyNonStickyRows = data.some((row) => !row.sticky)

  return (
    <>
      {showRowGroupTitle && (
        <RowGroupTitle
          groupKey={groupKey}
          groupSize={groupSize}
          groupValues={groupValues}
          expanded={expanded}
          onGroupCollapseToggle={onGroupCollapseToggle}
        />
      )}
      {showDataRows && <DataRows rows={data} onRowClick={onRowClick} />}
      {showGroupTotals && (
        <>
          {hasMultipleStickyRows && showDataRows && (
            <RowGroupSummary
              groupKey={groupKey}
              groupNumber={groupNumber}
              groupValues={groupValues}
              groupTotals={stickyGroupTotals}
              isStickySummary
            />
          )}
          {hasAnyNonStickyRows && (
            <RowGroupSummary
              groupKey={groupKey}
              groupNumber={groupNumber}
              groupValues={groupValues}
              groupTotals={groupTotals}
            />
          )}
        </>
      )}
    </>
  )
}
